import { useMemo } from 'react';
import './Sky.css';

/**
 * 全站背景星空层。手机端密度自动降低。
 * 不响应任何交互，永远在最底层缓慢呼吸。
 */
export default function Sky({ density }) {
  const stars = useMemo(() => {
    const isSmall = typeof window !== 'undefined' && window.innerWidth < 520;
    const n = density ?? (isSmall ? 50 : 86);
    return Array.from({ length: n }, () => ({
      x: (Math.random() * 100).toFixed(2),
      y: (Math.random() * 100).toFixed(2),
      s: (Math.random() * 2 + 0.6).toFixed(2),
      d: (Math.random() * 3.5 + 2.5).toFixed(2),
      delay: (Math.random() * 4).toFixed(2),
    }));
  }, [density]);

  return (
    <div className="sky" aria-hidden="true">
      {stars.map((st, i) => (
        <span
          key={i}
          className="bgstar"
          style={{
            left: `${st.x}%`,
            top: `${st.y}%`,
            width: `${st.s}px`,
            height: `${st.s}px`,
            '--dur': `${st.d}s`,
            animationDelay: `${st.delay}s`,
          }}
        />
      ))}
    </div>
  );
}
